'use client'

import { getCloudflareImageUrl } from '@fusion/media/cloudflare'

import type { ImageLoaderProps } from 'next/image'

// Next.js loaderFile requires a default export. Package source uses named exports.
export default function cloudflareImageLoader(props: ImageLoaderProps): string {
  return getCloudflareImageUrl({ ...props, relativePaths: 'preserve' })
}
